<h1 mat-dialog-title>Primanota-Export-Vorschau</h1>
<div mat-dialog-content class="vorschau-content">
    <div class="modus-bar">
        <button
            mat-stroked-button
            type="button"
            [color]="modus === 'neu' ? 'primary' : undefined"
            [class.active]="modus === 'neu'"
            (click)="setModus('neu')"
        >
            Neu (Journal)
        </button>
        <button
            mat-stroked-button
            type="button"
            [color]="modus === 'alt' ? 'primary' : undefined"
            [class.active]="modus === 'alt'"
            (click)="setModus('alt')"
            matTooltip="Frühere Logik: Aufwand = Lieferant-Gegenkonto, eine Zeile je MwSt"
        >
            Alt (Legacy)
        </button>
    </div>

    <p class="hint">
        {{ aktiv.beschreibung }}
        Quelle: {{ data.quelle }}. Noch keine echte Primanota.
    </p>

    <div class="hinweise" *ngIf="aktiv.hinweise?.length">
        <div class="hinweis" *ngFor="let h of aktiv.hinweise">{{ h }}</div>
    </div>

    <div class="empty" *ngIf="!aktiv.zeilen?.length">Keine Buchungszeilen ableitbar.</div>

    <div class="table-wrap" *ngIf="aktiv.zeilen?.length">
        <table>
            <thead>
                <tr>
                    <th>Umsatz</th>
                    <th>S/H</th>
                    <th>Konto</th>
                    <th>Gegenkonto</th>
                    <th>BU</th>
                    <th>Belegdatum</th>
                    <th>Beleg</th>
                    <th>Buchungstext</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let z of aktiv.zeilen">
                    <td class="num">{{ formatEuro(z.umsatz) }}</td>
                    <td>{{ z.sollhaben }}</td>
                    <td class="mono">{{ z.konto || '–' }}</td>
                    <td class="mono">{{ z.gegenkonto || '–' }}</td>
                    <td class="mono">{{ z.bu_schluessel ?? '' }}</td>
                    <td>{{ z.belegdatum }}</td>
                    <td>{{ z.beleg }}</td>
                    <td class="text">{{ z.buchungstext }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="button" (click)="close()">Schließen</button>
</div>
